"use client"
import React, { useState, useEffect, useRef, useMemo } from 'react';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
//import BlockViewer from '../BlockViewer';

import { PlantillaService } from '../service/PlantillaService';
import AuthStorage from '../storage/AuthStorage';
import AuthController from '../controller/AuthController';
import { getConfigSubdomainDefault, GetCurrentUserDefault } from '../storage/getConfigSubdomainDefault';


import '../App.css';

const BlocksLogin = ({ props }) => {

    console.log("blocklogin.js");

    const authController = new AuthController();

    const [authStorage, setAuthStorage] = useState(undefined);

    const [dataConfigSubdomain, setDataConfigSubdomain] = useState(getConfigSubdomainDefault);
    let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit, urlLogoLogin } = dataConfigSubdomain;



    const userDetails = authStorage ? authStorage.GetCurrentUser() : GetCurrentUserDefault();
    let { userName, idEmpresa, idioma, sessionGUID, documentoInvitado } = userDetails;


    const urlFullLogoLoginDefault = "assets/layout/images/logo-login.png";

    let urlFullLogoLogin = urlLogoLogin ? process.env.NEXT_PUBLIC_URL_API + urlLogoLogin : urlFullLogoLoginDefault;

    //const { user: ContextState, configSubdomain, login } = useContext(AuthProvider);
    //const {isLoginPending,isLoggedIn,loginError, subdomain, userName, idSuscripcion, idEmpresa, idioma } = ContextState;

    //const authService = new AuthService();



    const plantillaService = new PlantillaService();

    const codMenu = "LOGIN";

    const [etiquetasMenu, setEtiquetasMenu] = useState([]);
    const [intentoErrado, setIntentoErrado] = useState(0);
    const [vecesBotonPresionado, setVecesBotonPresionado] = useState(0);

    useEffect(() => {

        console.log("useEffect_BlocksLogin, ");

        const authStorage = new AuthStorage(window.location.pathname);
        let mewdataConfigSubdomain = authStorage.getConfigSubdomain();

        subdomain = mewdataConfigSubdomain.subdomain;
        idSuscripcion = mewdataConfigSubdomain.idSuscripcion;
        idEmpresaInit = mewdataConfigSubdomain.idEmpresaInit;
        idiomaInit = mewdataConfigSubdomain.idiomaInit;

        setAuthStorage(authStorage);
        setDataConfigSubdomain(mewdataConfigSubdomain);

        const userDetails = authStorage.GetCurrentUser();
        userName = userDetails.userName;
        idioma = userDetails.idioma;
        idEmpresa = userDetails.idEmpresa;
        sessionGUID = userDetails.sessionGUID
        documentoInvitado = userDetails.documentoInvitado

        setForm({
            idSuscripcion: idSuscripcion,
            idioma: idiomaInit,
            idEmpresa: idEmpresaInit,
            subdomain: subdomain,
            userName: '',
            password: ''
        })


        loadDatosBase();

    }, []);

    const loadDatosBase = () => {

        plantillaService.getEtiquetasMenuAuth(idEmpresaInit, idiomaInit, codMenu).then(data => {
            console.log("getEtiquetasMenuAuth, ", data);
            setEtiquetasMenu(data);
        });
    }

    const [checked, setChecked] = useState(false);
    const [form, setForm] = useState({
        idSuscripcion: idSuscripcion,
        idioma: idiomaInit,
        idEmpresa: idEmpresaInit,
        subdomain: subdomain,
        userName: '',
        password: ''
    });

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _form = { ...form };
        _form[`${name}`] = val;
        setForm(_form);
    }


    const clickLogin = async (e) => {

        //e.preventDefault();
        try {

            if (form.userName !== "" && form.password !== "") {

                let response = await authController.loginUser(form) //loginUser action makes the request and handles all the neccessary state changes
                //console.log(props.nextProps);
                if (response.sessionGUID !== null && response.sessionGUID !== "")
                    window.location.href = process.env.NEXT_PUBLIC_FOLDER_APP + "/home";
                //window.location.href ='/generica2'; //navigate to dashboard on success
                else
                    setIntentoErrado((prev) => prev + 1);

            }
            else {

            }
        } catch (error) {
            console.log(error)
        }

        setVecesBotonPresionado(prev => prev + 1);

    }

    function GetTextoEtiqueta(etiqueta) {
        return (etiquetasMenu.filter(et => et.etiqueta === etiqueta).map(et => et.ctiTexto));
    }

    const mensajeError = (_intentoErrado) => {

        if (vecesBotonPresionado > 0) {
            if (form.userName === "" || form.password === "") {
                return (<label htmlFor="btLogin" >Debe ingresar credenciales.</label>);
            }
            else if (intentoErrado > 0)
                return (<label htmlFor="btLogin" >Nombre de usuario o contraseña incorrecto.</label>);
        }
        else
            return (<></>);
    }


    //
    return (


        <div className="surface-card p-4 shadow-2 border-round w-full lg:w-6">
            <div className="text-center mb-5">
                <img src={urlFullLogoLogin} alt="hyper" height="150" className="mb-3" />
                <div className="text-900 text-3xl font-medium mb-3">{subdomain === "siac" ? GetTextoEtiqueta("Label_Bienvenida") : "Bienvenido a Portal PRISMAU"}</div>
                <span style={{ display: "none" }} className="text-600 font-medium line-height-3">{GetTextoEtiqueta("Label_NoTieneCuenta")}</span>
                <button style={{ display: "none" }} className="p-link font-medium no-underline ml-2 text-blue-500 cursor-pointer">{GetTextoEtiqueta("Label_CrearCuentaHoy")}</button>
            </div>

            <div>
                <label htmlFor="userName1" className="block text-900 font-medium mb-2">{GetTextoEtiqueta("Label_UserName")}</label>
                <InputText id="userName" type="text" onChange={(e) => onInputChange(e, 'userName')} className="w-full mb-3" value={form.userName} />

                <label htmlFor="password" className="block text-900 font-medium mb-2">{GetTextoEtiqueta("Label_Password")}</label>
                <InputText id="pwd" type="password" onChange={(e) => onInputChange(e, 'password')} className="w-full mb-3" />

                <div className="flex align-items-center justify-content-between mb-6">

                    <button style={{ display: "none" }} className="p-link font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer">{GetTextoEtiqueta("Label_OlvidoContraseña?")}</button>


                </div>
                {mensajeError(intentoErrado)}
                <Button id='btLogin' onClick={clickLogin} label={GetTextoEtiqueta("BotonLabel_Entrar")} icon="pi pi-user" className="w-full" />




            </div>



        </div>
    )
}

/*
<div className="flex align-items-center">
                            <Checkbox inputId="rememberme1" binary className="mr-2" onChange={e => setChecked(e.checked)} value={form.password} checked={checked} />
                            <label htmlFor="rememberme1">{GetTextoEtiqueta("Label_NoCerrarSesion")}</label>
                        </div>
*/

/*const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(BlocksLogin, comparisonFn);*/

export default BlocksLogin;
